module.exports = __webpack_public_path__ + "img/pro_one_9.eaf0b774.jpg";